import React from 'react';

import ManageListboxes from './Admin/ManageListboxes';
import ManagePrivileges from './Admin/ManagePrivileges';

import ApproveAppointments from './ApproveAppointments';
import Appointments from './NewAppointments';
import EmployeePendencies from './ApproveAppointments/InternalPages/EmployeePendencies';

import ApproveRefunds from './ApproveRefunds';
// import ApprovePayments from './ApprovePayments';
import EmployeeRefunds from './Refunds';
import RequestRefunds from './Refunds/InternalPages/RequestRefunds';

import Clients from './Clients';
import ManageClients from './Clients/InternalPages/ManageClients';

import Employees from './Employees';
import ManageEmployees from './Employees/InternalPages/ManageEmployees';

import Projects from './CoordinateProjects';
import AddSales from './CoordinateProjects/InternalPages/AddSales';
import AllocateProfessionals from './CoordinateProjects/InternalPages/AllocateProfessionals';
import CreateNewProject from './CoordinateProjects/InternalPages/CreateNewProject';
import ManageProject from './CoordinateProjects/InternalPages/ManageProject';

import PDI from './PDI';
import Tutorial from './PDI/InternalPages/Tutorial';
import EvaluationForm from './PDI/InternalPages/EvaluationForm';
import Resume from './PDI/InternalPages/Resume';
import Results from './PDI/InternalPages/Results';
import TeamEvaluation from './PDI/InternalPages/TeamEvaluation';
import Configurations from './PDI/InternalPages/Configurations';

const Pages = [
  {
    route: '/auth/admin/manage-privileges',
    isExact: true,
    page: props => <ManagePrivileges {...props} />,
    permissionId: [1],
  },
  {
    route: '/auth/admin/manage-listboxes',
    isExact: true,
    page: props => <ManageListboxes {...props} />,
    permissionId: [2],
  },
  {
    route: '/auth/appointments',
    isExact: true,
    page: props => <Appointments {...props} />,
    permissionId: [3],
  },
  {
    route: '/auth/approve-appointments',
    isExact: true,
    page: props => <ApproveAppointments {...props} />,
    permissionId: [4],
  },
  {
    route: '/auth/appointments/pendencies',
    isExact: true,
    page: props => <EmployeePendencies {...props} />,
    permissionId: [5],
  },
  {
    route: '/auth/appointments/admin',
    isExact: true,
    page: props => <Appointments {...props} />,
    permissionId: [6],
  },
  {
    route: '/auth/coordinate-projects',
    isExact: true,
    page: props => <Projects {...props} />,
    permissionId: [7],
  },
  {
    route: '/auth/coordinate-projects/manage-project',
    isExact: true,
    page: props => <ManageProject {...props} />,
    permissionId: [8],
  },
  {
    route: '/auth/coordinate-projects/manage-project/allocate-professionals',
    isExact: true,
    page: props => <AllocateProfessionals {...props} />,
    permissionId: [9],
  },
  {
    route: '/auth/coordinate-projects/add-project',
    isExact: true,
    page: props => <CreateNewProject {...props} />,
    permissionId: [10],
  },
  {
    route: '/auth/coordinate-projects/add-sales',
    isExact: true,
    page: props => <AddSales {...props} />,
    permissionId: [11],
  },
  {
    route: '/auth/clients',
    isExact: true,
    page: props => <Clients {...props} />,
    permissionId: [12],
  },
  {
    route: '/auth/clients/add-client',
    isExact: true,
    page: props => <ManageClients {...props} />,
    permissionId: [13],
  },
  {
    route: '/auth/clients/edit-client',
    isExact: true,
    page: props => <ManageClients {...props} />,
    permissionId: [14],
  },
  {
    route: '/auth/employees',
    isExact: true,
    page: props => <Employees {...props} />,
    permissionId: [15],
  },
  {
    route: '/auth/employees/add-employee',
    isExact: true,
    page: props => <ManageEmployees {...props} />,
    permissionId: [16],
  },
  {
    route: '/auth/employees/edit-employee',
    isExact: true,
    page: props => <ManageEmployees {...props} />,
    permissionId: [17],
  },
  {
    route: '/auth/appointments/request-refunds',
    isExact: true,
    page: props => <RequestRefunds {...props} />,
    permissionId: [18],
  },
  {
    route: '/auth/appointments/refunds-history',
    isExact: true,
    page: props => <EmployeeRefunds {...props} />,
    permissionId: [19],
  },
  {
    route: '/auth/appointments/refunds-history/edit-refunds',
    isExact: true,
    page: props => <RequestRefunds {...props} />,
    permissionId: [20],
  },
  {
    route: '/auth/approve-refunds',
    isExact: true,
    page: props => <ApproveRefunds {...props} />,
    permissionId: [21],
  },
  // {
  //   route: '/auth/approve-payments',
  //   isExact: true,
  //   page: props => <ApprovePayments {...props} />,
  //   permissionId: [[1, 2, 3, 4, 5, 6,]7
  // },
  {
    route: '/auth/pdi',
    isExact: true,
    page: props => <PDI {...props} />,
    permissionId: [25, 29],
  },
  {
    route: '/auth/pdi/tutorial',
    isExact: true,
    page: props => <Tutorial {...props} />,
    permissionId: [26],
  },
  {
    route: '/auth/pdi/evaluation',
    isExact: true,
    page: props => <EvaluationForm {...props} />,
    permissionId: [27],
  },
  {
    route: '/auth/pdi/evaluation/resume',
    isExact: true,
    page: props => <Resume {...props} />,
    permissionId: [28],
  },
  {
    route: '/auth/pdi/results',
    isExact: true,
    page: props => <Results {...props} />,
    permissionId: [22],
  },
  {
    route: '/auth/pdi/team-evaluation',
    isExact: true,
    page: props => <TeamEvaluation {...props} />,
    permissionId: [23],
  },
  {
    route: '/auth/pdi/evaluations-config',
    isExact: true,
    page: props => <Configurations {...props} />,
    permissionId: [24],
  },
];

export default Pages;
